import React from "react";

import FixedHeightWrapper from "app/meets/FixedHeightWrapper";
import TeamResultsTable from "./TeamResultsTable";
import "./TeamResultsIndex.scss";
import { useMeet } from "util/useMeet";

const TeamResultsIndex = () => {
  const meet = useMeet();

  return (
    <FixedHeightWrapper>
      <div className="results-index">
        <TeamResultsTable meet={meet} />
      </div>
    </FixedHeightWrapper>
  );
};

export default TeamResultsIndex;
